<template>
  <div class="flex flex-col items-center">
    <!-- Hero section with background image, heading, subheading and button -->
    <div
      class="relative overflow-hidden bg-cover bg-no-repeat w-full hero-bg"
      style="
        height: 150px;
      ">
      <div
        class="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-fixed"
        style="background-color: rgba(255, 255, 255, 0.15)">
      </div>
    </div>
    <div class="w-full">
      <div class="flex h-full items-center justify-start m-auto max-w-7xl">
        <div class="relative -mt-16 px-2 py-4">
          <div
            class="w-96 block rounded bg-white p-6 dark:bg-neutral-700 multi-shadow">
            <h1 class="font-semibold text-2xl p-4">MRC Albums</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- Hero section with background image, heading, subheading and button -->
    <div class="w-full flex flex-col max-w-7xl py-10">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-stretch">
        <div
          class='block px-4 py-1 rounded-lg hover:border hover:border-pink-200 hover:border-b-0 hover:shadow-lg border mx-2 my-5 bg-gray-100'
          v-for='item in albumItems'
          :key="item.title"
        >
          <div class='flex-grow w-12/12 sm:pl-4'>
            <div class="flex w-full mt-4 inset-shadow-sm h-60 overflow-hidden">
              <img :src='item.img' class="w-full h-full rounded-lg" />
            </div>
            <h2 class='text-lg font-medium text-gray-900 title-font pt-2'>
              {{ item.title }}
            </h2>
            <div class="flex float-left">
              <div v-if="item.videoURL!=''">
                <a
                  :href='item.videoURL'
                  :target="item.newWindow?'_blank':'_self'"
                  role='link'
                  type="button"
                  class="ml-4 mt-4 mb-4 justify-center py-2 px-4
                        border border-transparent
                        text-sm leading-5 font-medium text-white bg-red-600
                        hover:bg-red-500 focus:outline-none focus:border-red-700
                        focus:shadow-outline-red active:bg-red-700
                        transition duration-150 ease-in-out rounded"
                >
                  Video
                </a>
              </div>
            </div>
            <div class="flex float-right">
              <div v-if="item.photoURL!=''">
                <a
                  :href='item.photoURL'
                  :target="item.newWindow?'_blank':'_self'"
                  type="button"
                  class="ml-4 mt-4 mb-4 justify-center py-2 px-4
                        border border-transparent
                        text-sm leading-5 font-medium text-white bg-red-600
                        hover:bg-red-500 focus:outline-none focus:border-red-700
                        focus:shadow-outline-red active:bg-red-700
                        transition duration-150 ease-in-out rounded"
                >
                  Photos
                </a>
              </div>
            </div>
            <!-- <img src='../assets/arrowlink.svg' class="w-8 h-8 float-right" /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="w-full h-20 flex flex-col items-center b4footer-bg">
      &nbsp;
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      albumItems: Object.freeze([
        {
          title: 'MRC 2026 Symposium (Singapore)',
          desc: 'MRC 2026 Symposium (Singapore) event coverage held in VOCO Hotel Orchard.',
          photoURL: 'https://photos.app.goo.gl/xx5vmxGerm8dvH1u7',
          videoURL: '',
          permissions: [''],
          // eslint-disable-next-line global-require
          img: require('@/assets/album/2026_MRC_Symposium_SG.jpg'),
          // eslint-disable-next-line global-require
          icon: '',
          color: 'bg-gray-100',
          newWindow: true,
        },
        {
          title: 'MRC 2025 Symposium (Singapore)',
          desc: 'MRC 2025 Symposium (Singapore) event coverage held in Marriott Hotel Orchard.',
          photoURL: 'https://photos.app.goo.gl/i4Bj8616YbBrB9bX9',
          videoURL: 'https://youtu.be/5uAiifX8nY0',
          permissions: [''],
          // eslint-disable-next-line global-require
          img: require('@/assets/album/2025_MRC_Symposium_SG.jpeg'),
          // eslint-disable-next-line global-require
          icon: '',
          color: 'bg-gray-100',
          newWindow: true,
        },
        {
          title: 'MRC 2024 Symposium (Singapore)',
          desc: 'MRC 2024 Symposium (Singapore) event coverage held in Royal Plaza on Scotts Orchard.',
          photoURL: 'https://photos.app.goo.gl/mvPZVieyW8UCs8Ei9',
          videoURL: 'https://youtu.be/mfGc5eKAHSU',
          permissions: [''],
          // eslint-disable-next-line global-require
          img: require('@/assets/album/2024_MRC_Symposium_SG.jpg'),
          // eslint-disable-next-line global-require
          icon: '',
          color: 'bg-gray-100',
          newWindow: true,
        },
        {
          title: 'MRC 2024 Symposium (Hong Kong)',
          desc: 'MRC 2024 Symposium (Hong Kong) event coverage.',
          photoURL: 'https://photos.app.goo.gl/qvkziBCZmp6kwdYu9',
          videoURL: '',
          permissions: [''],
          // eslint-disable-next-line global-require
          img: require('@/assets/album/2024_MRC_Symposium_HK.jpg'),
          // eslint-disable-next-line global-require
          icon: '',
          color: 'bg-gray-100',
          newWindow: true,
        },
      ]),
    };
  },
});
</script>

<style>
.hero-bg {
  background: url('../assets/img/gallery.jpg') top;
  background-size: cover;
  background-repeat: no-repeat;
}
.b4footer-bg {
  background: url('../assets/img/background/testimonial.jpg') top;
}
.multi-shadow {
  /* box-shadow: -10px 10px 0px rgba(33, 33, 33, 0.7), -20px 20px 0px rgba(33, 33, 33, 0.4), -30px 30px 0px rgba(33, 33, 33, 0.1); */
  box-shadow:
  5px 5px 0 0 rgba(36, 11, 54,0.3),
  10px 10px 0 0 rgba(241, 39, 17,0.2),
  15px 15px 0 0 rgba(195, 20, 50,0.1);
}
</style>
